var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./DateTimeStyle.scss";
import { EventHandler } from "../../interaction/eventhandler";
import { DateComponent } from "../date/DateComponent";
import { TimeComponent } from "../time/TimeComponent";
var DateTimeComponent = /** @class */ (function () {
    function DateTimeComponent(options) {
        var _this = this;
        if (options.bindMode && options.bindMode !== "toModel") {
            throw new Error("Currently DateTimeComponent only supports toModel as bindMode");
        }
        this.options = __assign({}, options);
        this.options.onChange = EventHandler.Create(this.options.onChange);
        var optionsCopy = __assign({}, options);
        optionsCopy.bindTo = null;
        optionsCopy.property = null;
        optionsCopy.converter = null;
        optionsCopy.onChange = function () {
            var _a;
            var val = _this.getValueAsDate();
            if (_this.options.bindTo && options.property) {
                _this.options.bindTo[options.property] =
                    ((_a = _this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? _this.options.converter.toData(val) : val;
            }
            _this.options.onChange.notify(val);
        };
        this.dateComp = new DateComponent(optionsCopy);
        this.timeComp = new TimeComponent(optionsCopy);
    }
    DateTimeComponent.prototype.render = function () {
        return { tag: "div", attr: { class: "date-time-comp" }, children: [
                this.dateComp, this.timeComp
            ] };
    };
    DateTimeComponent.prototype.getValue = function () {
        return this.dateComp.getValue() + " " + this.timeComp.getValue();
    };
    DateTimeComponent.prototype.getValueAsDate = function () {
        return this.timeComp.getValueAsDate(this.dateComp.getValueAsDate());
    };
    return DateTimeComponent;
}());
export { DateTimeComponent };
